
window.config = {
    title: 'SW - A Sua Cor',
    baseUri: 'https://api.swflow.com/',
    chatUri: 'https://api.swflow.com/signalr',
    chatHubsUrl: 'https://api.swflow.com/signalr/hubs',
    defaultImage: 'https://cdn.swflow.com/default.png',
    cdnUrl: 'https://cdn.swflow.com/',
    cdnUrlFilesTempPath: 'https://cdn.swflow.com/files/temp',
    version: '2.0',
    projectModule: 'Colors',
    rootLangFolder: '',
    defaultPageSize: 10,

    themeColor: '#b71234',
    broswerConfig: '/images/Favicons/asuacor-browserconfig.xml',
    faviconUrlApple: '/images/Favicons/asuacor-apple-touch-icon.png',
    faviconUrl32: '/images/Favicons/asuacor-favicon-32x32.png',
    faviconUrl16: '/images/Favicons/asuacor-favicon-16x16.png',
    faviconUrl: '/images/Favicons/asuacor-favicon.ico'
};

window.systemMessages = {
    sessionExpired: 'Sessão expirada. Por favor efetue o login novamente.'
};

window.enumerators = {
    statusApproval: { "Pendente": 1, "Aprovado": 2, "Reprovado": 3, "Cancelado": 4 },
    productSegment: { "ARCH": 1, "AERO": 2 },
    attachmentType: { "PromotionProof": 1, "Invoice": 2, "Mechanics": 3, "Layout": 4, "AcquittanceDoc": 5, "Financial": 6, "Design": 7, "Project": 8, "InvoiceSale": 9, "AuxDocuments": 10 },
    revenueType: { "YTD": 1, "FullYear": 2 },
    modules: { "Acoes": 1, "Cores": 2 },
    statusColor: { "EmEspera": 500, "AguardandoIniciodeProducao": 510, "EmProducao": 520, "AguardandoSolicitante": 530, "AguardandoAnaliseSW": 540, "RevisaoSolicitadaSW": 550, "ProjetoVerificado12": 560, "RevisaoSolicitadaConsumidor": 570, "ProjetoAprovado": 580, "ConcluidoVenda": 590, "ConcluidoSemVenda": 600, "ProjetoVerificado22": 610 },
    customersTypes: { "Revenda": 1, "Propria": 2 },
    disapprovalReasonsTypes: { "Consumidor": 1, "SemVenda": 2 },
    enumGroupsColorsRequests: { "VendedorBalcao": 1017, "Designer": 1018, "GerenteRegional": 1021, "Financeiro": 1024, "ControleQualidade": 1025, "GerenteNacional": 1026 },
};